{
  "codexEntityForm": {
    "character": "Figur",
    "place": "Ort",
    "faction": "Fraktion",
    "object": "Gegenstand",
    "concept": "Konzept",
    "editName": "{{name}} bearbeiten",
    "newCodexEntry": "Neuer Kodex-Eintrag",
    "theWorldHasChangedTheDraft": "Die Welt hat sich geändert. Der Entwurf bleibt erhalten; lade den Eintrag vor dem Speichern neu.",
    "portraitChooseAnImage": "Porträt: Bild auswählen",
    "change": "Ändern",
    "addPortrait": "Porträt hinzufügen",
    "portraitImage": "Porträtbild",
    "entryName": "Name des Eintrags",
    "name": "Name",
    "entryType": "Eintragstyp",
    "customCategory": "Eigene Kategorie",
    "categoryEGDeityShipSpell": "Kategorie, z. B. Gottheit, Schiff, Zauber",
    "aliases": "Aliase",
    "entryAliases": "Aliase des Eintrags",
    "otherNamesOneAtATime": "Andere Namen, einzeln …",
    "tags": "Tags",
    "entryTags": "Tags des Eintrags",
    "themesRolesArcs": "Themen, Rollen, Handlungsbögen …",
    "collection": "Sammlung",
    "entryCollection": "Sammlung des Eintrags",
    "noCustomCollection": "Keine eigene Sammlung",
    "folder": "Ordner",
    "entryFolder": "Ordner des Eintrags",
    "unfiled": "Nicht abgelegt",
    "notes": "Notizen",
    "entryNotes": "Notizen zum Eintrag",
    "whoTheyAreWhatTheyWant": "Wer sie sind, was sie wollen, was die Leserschaft nie zu früh erfahren darf …",
    "entryFields": "Felder des Eintrags",
    "fields": "Felder",
    "fieldTemplate": "Feldvorlage",
    "template": "Vorlage …",
    "schemaOf": "Schema von",
    "addMissingFields": "Fehlende Felder hinzufügen",
    "addField": "Feld hinzufügen",
    "noCustomFieldYetFieldsGive": "Noch kein eigenes Feld. Felder geben einem Eintrag strukturierte Fakten – Alter, Zugehörigkeit, ein Geheimnis –, mit denen die Prüfungen arbeiten können.",
    "sharedFieldNamesTypesAndOptions": "Gemeinsame Feldnamen, Typen und Optionen verwaltest du in den Sammlungseinstellungen. Die Werte gehören zu dieser Seite.",
    "fieldNameN": "Feldname {{n}}",
    "fieldName": "Feldname",
    "fieldTypeN": "Feldtyp {{n}}",
    "unknown": "Unbekannt",
    "fieldValueN": "Feldwert {{n}}",
    "select": "Auswählen …",
    "yes": "Ja",
    "no": "Nein",
    "value": "Wert",
    "chooseAnEntry": "Eintrag auswählen …",
    "eGSpringOfYear12": "z. B. Frühling im Jahr 12 oder der Tag der Belagerung",
    "below": "Darunter",
    "unknownValueN": "Unbekannter Wert {{n}}",
    "required": "Pflichtfeld",
    "sharedField": "Gemeinsames Feld",
    "remove": "Entfernen",
    "confirmRemoval": "Entfernen bestätigen",
    "paragraph": "Absatz",
    "aFewLines": "Ein paar Zeilen …",
    "discardTheDraft": "Entwurf verwerfen?",
    "confirmReload": "Neu laden bestätigen",
    "keepEditing": "Weiterbearbeiten",
    "reloadEntry": "Eintrag neu laden",
    "cancel": "Abbrechen",
    "chooseAnImageFileForThe": "Wähle eine Bilddatei für das Porträt.",
    "thePortraitMustBeUnder8": "Das Porträt muss kleiner als 8 MiB sein.",
    "saveEntry": "Eintrag speichern",
    "searchEntries": "Einträge suchen …"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Neuer Kodex-Eintrag",
    "savedToWorldCodexTheManuscript": "In Welt › Kodex gespeichert; das Manuskript erwähnt ihn dort, wo du getippt hast.",
    "createAndMention": "Erstellen und erwähnen"
  },
  "continuityPanel": {
    "relationsOverTime": "Beziehungen im Zeitverlauf",
    "checkingRelations": "Beziehungen werden geprüft …",
    "cancel": "Abbrechen",
    "theProjectHasChangedRunThe": "Manuskript oder Welt haben sich seit diesem Durchlauf geändert. Starte die Prüfungen erneut, um die Beziehungen zu aktualisieren.",
    "anAnalysisLimitWasReachedThe": "Ein Analyselimit wurde erreicht. Das Ergebnis ist unvollständig.",
    "ruleApplied": "Regel: „{{label}}“, {{rule}}.",
    "oneSourcePerTarget": "eine Quelle pro Ziel",
    "oneTargetPerSource": "ein Ziel pro Quelle",
    "interval": "von {{start}} bis {{end}}",
    "openScene": "{{scene}} öffnen",
    "findingReferenceMissing": "Verweist auf einen Eintrag, den es nicht mehr gibt.",
    "findingConfirmedWithoutEvidence": "Bestätigt ohne Zitat aus dem Text, daher lässt sich die Quelle nicht prüfen.",
    "findingEvidenceMissing": "Ein Zitat, auf das sie sich stützt, ist verschwunden.",
    "findingEvidenceNotCurrent": "Ein Zitat, auf das sie sich stützt, ist nicht bestätigt oder passt nicht mehr zum Text.",
    "findingExclusiveNotEvaluable": "Lässt sich nicht an der Regel prüfen: Es braucht eine Richtung, beide Enden und einen vollständigen Zeitraum.",
    "findingExclusiveOverlap": "Zwei davon gelten zur selben Zeit, was die Regel nicht erlaubt.",
    "findingOther": "In dieser Beziehung gibt es etwas zu prüfen.",
    "theProjectExceedsTheLimitOf": "Das Projekt überschreitet das Limit dieser Analyse. Es wurden keine Daten geändert.",
    "theAnalysisExceededItsExecutionLimit": "Die Analyse hat ihr Ausführungslimit überschritten. Es wurden keine Daten geändert.",
    "analysisCancelled": "Analyse abgebrochen.",
    "checksNotCompletedTheTextAnd": "Prüfungen nicht abgeschlossen. Text und Kanon wurden nicht geändert."
  },
  "eventTimelinePanel": {
    "eventHistory": "Ereignisverlauf",
    "timeline": "Zeitleiste",
    "newEvent": "Neues Ereignis",
    "searchEvents": "Ereignisse durchsuchen",
    "searchEvents2": "Ereignisse durchsuchen …",
    "timelineOrder": "Reihenfolge der Zeitleiste",
    "storyTime": "Erzählte Zeit",
    "readingOrder": "Lesereihenfolge",
    "dateStatus": "Datumsstatus",
    "allDates": "Alle Daten",
    "resolvedDates": "Aufgelöste Daten",
    "unresolvedDates": "Nicht aufgelöste Daten",
    "filterEventsByScene": "Ereignisse nach Szene filtern",
    "allScenes": "Alle Szenen",
    "scenes": "Szenen",
    "editEvent": "Ereignis bearbeiten",
    "closeEventEditor": "Ereignis-Editor schließen",
    "theWorldHasChangedReloadThe": "Die Welt hat sich geändert. Lade das Ereignis vor dem Speichern neu; die Entwurfsfelder bleiben erhalten.",
    "eventTitle": "Titel des Ereignisses",
    "whatHappens": "Was geschieht",
    "scene": "Szene",
    "eventScene": "Szene des Ereignisses",
    "notLinked": "Nicht verknüpft",
    "removedSceneSceneid": "Entfernte Szene — {{sceneId}}",
    "dateType": "Datumsart",
    "eventDateType": "Datumsart des Ereignisses",
    "unknown": "Unbekannt",
    "definedInterval": "Festgelegter Zeitraum",
    "relativeToAnEvent": "Relativ zu einem Ereignis",
    "start": "Beginn",
    "eventStart": "Beginn des Ereignisses",
    "endExclusive": "Ende (exklusiv)",
    "eventEnd": "Ende des Ereignisses",
    "referenceEvent": "Bezugsereignis",
    "select": "Auswählen …",
    "referenceToVerifyAnchoreventid": "Bezug prüfen — {{anchorEventId}}",
    "events": "Ereignisse",
    "offsetInTicks": "Versatz in Ticks",
    "eventOffset": "Versatz des Ereignisses",
    "saveEvent": "Ereignis speichern",
    "closeReload": "Schließen / neu laden …",
    "discardTheDraftChanges": "Entwurfsänderungen verwerfen?",
    "discardDraft": "Entwurf verwerfen",
    "reloadEvent": "Ereignis neu laden",
    "keepEditing": "Weiterbearbeiten",
    "noEventMatchesTheseFiltersEvents": "Kein Ereignis passt zu diesen Filtern. Ereignisse sind das, womit die Prüfungen arbeiten: wann etwas geschah und in welcher Szene die Leserschaft es erfährt.",
    "tickStart": "Tick {{start}}",
    "openScene": "Szene öffnen",
    "editTitle": "{{title}} bearbeiten",
    "removeTitle": "{{title}} entfernen",
    "confirmEventRemoval": "Entfernen des Ereignisses bestätigen",
    "cancel": "Abbrechen",
    "theWorldHasChangedCancelAnd": "Die Welt hat sich geändert: Brich ab und öffne die Bestätigung erneut.",
    "resolvedDate": "Aufgelöstes Datum",
    "unknownDate": "Unbekanntes Datum",
    "missingReference": "Fehlender Verweis",
    "timeCycle": "Zeitzyklus",
    "dateOutOfRange": "Datum außerhalb des Bereichs",
    "eventsFoundOfTotal_one": "{{count}} Ereignis gefunden · {{total}} insgesamt",
    "eventsFoundOfTotal_other": "{{count}} Ereignisse gefunden · {{total}} insgesamt",
    "removeThisEventReferences_one": "Dieses Ereignis entfernen? {{count}} direkter Verweis muss geprüft werden.",
    "removeThisEventReferences_other": "Dieses Ereignis entfernen? {{count}} direkte Verweise müssen geprüft werden.",
    "showMoreEvents_one": "{{count}} weiteres Ereignis anzeigen",
    "showMoreEvents_other": "{{count}} weitere Ereignisse anzeigen"
  },
  "fieldEditor": {
    "choose": "Auswählen …",
    "labelSearch": "Suche: {{label}}",
    "search": "Suchen …",
    "labelOptions": "Optionen: {{label}}",
    "noMatch": "Keine Treffer.",
    "optionsOnePerLine": "Optionen, eine pro Zeile",
    "fieldOptionsIndex": "Feldoptionen {{index}}",
    "addOptionIndex": "Option {{index}} hinzufügen",
    "newOption": "Neue Option",
    "addOption": "Option hinzufügen",
    "fieldValueIndex": "Feldwert {{index}}",
    "chooseOptions": "Optionen auswählen …",
    "chooseEntries": "Einträge auswählen …",
    "unsupportedMultiValueEditor": "Nicht unterstützter Mehrfachwert-Editor"
  },
  "graphExplorer": {
    "relationGraph": "Beziehungsgraph",
    "entry": "Eintrag",
    "filterGraphByEntry": "Graph nach Eintrag filtern",
    "all": "Alle",
    "status": "Status",
    "graphRelationStatus": "Beziehungsstatus im Graph",
    "proposedAndConfirmed": "Vorgeschlagen und bestätigt",
    "confirmed": "Bestätigt",
    "proposed": "Vorgeschlagen",
    "relation": "Beziehung",
    "searchRelationInTheGraph": "Beziehung im Graph suchen",
    "filterAtStoryTime": "Nach erzählter Zeit filtern",
    "tick": "Tick",
    "graphTick": "Tick des Graphen",
    "includeUnknownTime": "Unbekannte Zeit einbeziehen",
    "enterANumericTickOrTurn": "Gib einen numerischen Tick ein oder schalte den Zeitfilter aus.",
    "navigableRelationGraph": "Navigierbarer Beziehungsgraph",
    "selectName": "{{name}} auswählen",
    "entryCount_one": "{{count}} Eintrag",
    "entryCount_other": "{{count}} Einträge",
    "relationCount_one": "{{count}} Beziehung",
    "relationCount_other": "{{count}} Beziehungen",
    "hiddenBeyondViewLimit": "{{entries}} und {{relations}} jenseits der Ansichtsgrenze.",
    "relationsWithMissingEntries_one": "{{count}} Beziehung mit fehlenden Einträgen.",
    "relationsWithMissingEntries_other": "{{count}} Beziehungen mit fehlenden Einträgen.",
    "unknownDurationIncluded_one": "{{count}} Beziehung mit unbekannter Dauer ist im Filter enthalten.",
    "unknownDurationIncluded_other": "{{count}} Beziehungen mit unbekannter Dauer sind im Filter enthalten.",
    "unknownDurationExcluded_one": "{{count}} Beziehung mit unbekannter Dauer ist vom Filter ausgeschlossen.",
    "unknownDurationExcluded_other": "{{count}} Beziehungen mit unbekannter Dauer sind vom Filter ausgeschlossen."
  },
  "relationshipPanel": {
    "select": "Auswählen …",
    "removedReference": "Entfernter Verweis:",
    "projectRelations": "Beziehungen im Projekt",
    "relationsOf": "Beziehungen von",
    "filterRelationsByEntry": "Beziehungen nach Eintrag filtern",
    "allEntries": "Alle Einträge",
    "searchEntries": "Einträge durchsuchen …",
    "searchRelations": "Beziehungen durchsuchen",
    "relationOrEntry": "Beziehung oder Eintrag",
    "newRelation": "Neue Beziehung",
    "editRelation": "Beziehung bearbeiten",
    "relationsLinkTwoEntries": "Beziehungen verbinden zwei Einträge",
    "addTwoEntriesInTheCodex": "Füge im Kodex mindestens zwei Einträge hinzu und schreibe dann die Worte, die sie verbinden, etwa „ist der Mentor von“.",
    "theWorldHasChangedTheFields": "Die Welt hat sich geändert, während dies geöffnet war. Deine Felder bleiben erhalten; lade neu, um gegen die neuen Daten zu speichern.",
    "reload": "Neu laden",
    "anEntry": "Ein Eintrag",
    "anotherEntry": "Ein anderer Eintrag",
    "relationSource": "Quelle der Beziehung",
    "relationType": "Art der Beziehung",
    "isTheMentorOf": "ist der Mentor von",
    "relationTarget": "Ziel der Beziehung",
    "direction": "Richtung",
    "relationDirection": "Richtung der Beziehung",
    "oneWay": "Einseitig",
    "bothWays": "Beidseitig",
    "when": "Wann",
    "relationTime": "Zeit der Beziehung",
    "notSet": "Nicht festgelegt",
    "betweenTwoMoments": "Zwischen zwei Zeitpunkten",
    "fromAnEvent": "Ab einem Ereignis",
    "from": "Von",
    "to": "bis",
    "relationStart": "Beginn der Beziehung",
    "relationEnd": "Ende der Beziehung",
    "momentsHint": "Zeitpunkte auf der Zeitleiste der Welt; das Ende zählt nicht mit.",
    "event": "Ereignis",
    "relationEvent": "Ereignis der Beziehung",
    "offset": "Versatz",
    "relationOffset": "Versatz der Beziehung",
    "offsetHint": "Zeitpunkte nach dem Ereignis; negativ für davor.",
    "status": "Status",
    "relationStatus": "Status der Beziehung",
    "proposed": "Vorgeschlagen",
    "confirmed": "Bestätigt",
    "rejected": "Abgelehnt",
    "superseded": "Ersetzt",
    "confirmedRelationsCountAsCanonIn": "Bestätigte Beziehungen zählen in den Prüfungen als Kanon.",
    "notes": "Notizen",
    "relationNotes": "Notizen zur Beziehung",
    "howTheStoryShowsItAnd": "Wie die Geschichte sie zeigt und was mehrdeutig bleibt.",
    "quotes": "Zitate",
    "linkQuotes": "Zitate aus dem Text verknüpfen",
    "quotesLinked": "Zitate: {{count}}",
    "searchQuotations": "Zitate durchsuchen",
    "excerptOrNote": "Ausschnitt oder Notiz",
    "removedQuotation": "Entferntes Zitat:",
    "noQuotationYetAnnotateAPassage": "Noch kein Zitat. Annotiere eine Passage im Manuskript, um sie hier zu zitieren.",
    "upTo100QuotationsShownUse": "Bis zu 100 Zitate werden angezeigt. Grenze die Liste mit der Suche ein.",
    "saveRelation": "Beziehung speichern",
    "cancel": "Abbrechen",
    "aDeletedEntry": "ein gelöschter Eintrag",
    "aDeletedEvent": "ein gelöschtes Ereignis",
    "timeBetween": "Von {{start}} bis {{end}}",
    "timeAtEvent": "Bei {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Noch keine Beziehung.",
    "noRelationMatches": "Keine Beziehung passt.",
    "edit": "Bearbeiten",
    "editCaption": "{{caption}} bearbeiten",
    "remove": "Entfernen",
    "removeCaption": "{{caption}} entfernen",
    "removeThisRelationTheChangeStays": "Diese Beziehung entfernen? Die Änderung bleibt im Verlauf.",
    "confirmRemoval": "Entfernen",
    "shownOfTotal": "100 von {{total}} Beziehungen angezeigt. Grenze die Suche ein, um die anderen zu sehen.",
    "theWorldHasChangedReloadThe": "Die Welt hat sich geändert. Lade die Beziehung vor dem Speichern neu.",
    "theRelationWasChangedOrRemoved": "Die Beziehung wurde geändert oder entfernt. Lade die Daten neu.",
    "explicitlyConfirmTheRelationBeforeSaving": "Wähle erneut „Bestätigt“, damit diese Beziehung Kanon wird.",
    "selectTwoEntriesThatExistIn": "Wähle zwei Einträge aus, die im Kodex existieren.",
    "fillInTheTimeValuesOr": "Fülle die Zeitpunkte aus oder wähle „Nicht festgelegt“.",
    "enterAValidIntervalTheEnd": "Das Ende muss nach dem Beginn liegen.",
    "selectAnExistingEventAsThe": "Wähle ein Ereignis, das noch existiert.",
    "theSelectedQuotationIsNoLonger": "Ein gewähltes Zitat existiert nicht mehr.",
    "checkTheRelationTextAndThe": "Prüfe die Worte der Beziehung und die Notizen.",
    "theChangeWasNotSavedReload": "Die Änderung wurde nicht gespeichert. Lade die Daten neu und versuche es erneut."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Melde dich beim verknüpften Konto an und prüfe deinen Projektzugriff. Deine lokalen Änderungen bleiben erhalten.",
    "syncTheManuscriptWithThisServer": "Synchronisiere das Manuskript mit diesem Server, bevor du seine Welt verknüpfst.",
    "theWorldChangedAfterTheComparison": "Die Welt hat sich nach dem Vergleich geändert. Prüfe die aktuellen Kopien erneut.",
    "aConfirmationOrRestoredRecordNeeds": "Eine Bestätigung oder ein wiederhergestellter Datensatz muss ausdrücklich geprüft werden, bevor er synchronisiert werden kann.",
    "anAttachmentOrRemoteCopyFailed": "Bei einem Anhang oder einer Remote-Kopie ist die Überprüfung fehlgeschlagen. Deine lokale Welt bleibt erhalten.",
    "theseChangesExceedASyncLimit": "Diese Änderungen überschreiten ein Synchronisierungslimit oder müssen gemeinsam angewendet werden. Deine lokale Welt und die ausstehenden Änderungen bleiben erhalten.",
    "syncPausedYourLocalChangesAre": "Synchronisierung pausiert. Deine lokalen Änderungen bleiben erhalten.",
    "newMapNeedsPlan": "Neue Karten gehören zu Ink und Press. Die Karte bleibt auf diesem Gerät und die Welt wartet: Entferne die neue Karte oder wähle einen Tarif, um wieder zu synchronisieren.",
    "worldSyncCouldNotFinishCheck": "Die Synchronisierung der Welt konnte nicht abgeschlossen werden. Prüfe die Verbindung und versuche es erneut. Deine lokalen Änderungen bleiben erhalten."
  },
  "vaultFolders": {
    "folderName": "Ordner {{name}}",
    "editFolder": "Ordner bearbeiten",
    "newSubfolder": "Neuer Unterordner",
    "moveContentsBeforeRemoving": "Verschiebe vor dem Entfernen den Inhalt",
    "removeFolder": "Ordner entfernen",
    "folderActionsName": "Ordneraktionen {{name}}",
    "chooseThisFolderWhenEditingA": "Wähle diesen Ordner beim Bearbeiten einer Seite.",
    "projectFolders": "Projektordner",
    "folders": "Ordner",
    "newFolder": "Neuer Ordner",
    "groupPagesFromAnyCollection": "Fasse Seiten aus beliebigen Sammlungen zusammen.",
    "foldersOrganizePagesWithoutChangingTheir": "Ordner gliedern Seiten, ohne ihre Sammlung oder ihren Inhalt zu ändern.",
    "cancel": "Abbrechen",
    "saveFolder": "Ordner speichern",
    "name": "Name",
    "folderName2": "Ordnername",
    "inside": "Innerhalb von",
    "parentFolder": "Übergeordneter Ordner",
    "projectRoot": "Projektstamm",
    "removeEmptyFolder": "Leeren Ordner entfernen?",
    "removeNameFromTheProject": "„{{name}}“ aus dem Projekt entfernen?"
  },
  "vaultTable": {
    "unavailableEntry": "Eintrag nicht verfügbar",
    "vaultTable": "Archivtabelle",
    "pages": "Seiten",
    "searchVaultTable": "Archivtabelle durchsuchen",
    "searchPages": "Seiten durchsuchen …",
    "tableCollection": "Sammlung der Tabelle",
    "allCollections": "Alle Sammlungen",
    "noCustomCollection": "Keine eigene Sammlung",
    "tableFolder": "Ordner der Tabelle",
    "allFolders": "Alle Ordner",
    "unfiled": "Nicht abgelegt",
    "scrollableVaultTable": "Scrollbare Archivtabelle",
    "name": "Name",
    "collection": "Sammlung",
    "folder": "Ordner",
    "noPagesMatchTheseFilters": "Keine Seite passt zu diesen Filtern.",
    "none": "Keine",
    "yes": "Ja",
    "no": "Nein",
    "pagesShown_one": "{{shown}} von {{count}} Seite",
    "pagesShown_other": "{{shown}} von {{count}} Seiten"
  },
  "vaultTree": {
    "blue": "Blau",
    "emerald": "Smaragd",
    "gold": "Gold",
    "violet": "Violett",
    "rose": "Rosé",
    "amber": "Bernstein",
    "teal": "Petrol",
    "slate": "Schiefer",
    "crimson": "Karmesin",
    "bark": "Rinde",
    "forest": "Wald",
    "navy": "Marine",
    "orchid": "Orchidee",
    "saffron": "Safran",
    "ink": "Tinte",
    "ember": "Glut",
    "concept": "Konzept",
    "character": "Figur",
    "place": "Ort",
    "faction": "Fraktion",
    "object": "Gegenstand",
    "vault": "Archiv",
    "newCollection": "Neue Sammlung",
    "vaultView": "Archivansicht",
    "pages": "Seiten",
    "table": "Tabelle",
    "pagesMarkedUnassignedKeepTheirPrevious": "Als „nicht zugewiesen“ markierte Seiten behalten ihre bisherigen Felder. Bearbeite eine Seite, um ihre Sammlung zu wählen.",
    "filterPages": "Seiten filtern",
    "filterPages2": "Seiten filtern …",
    "worldVault": "Weltarchiv",
    "removeCollectionName": "Sammlung {{name}} entfernen",
    "collectionSettingsForName": "Sammlungseinstellungen für {{name}}",
    "iconAndColour": "Symbol und Farbe",
    "newPageInName": "Neue Seite in {{name}}",
    "noPageYetAddTheFirst": "Noch keine Seite — füge die erste mit + hinzu.",
    "nothingHereYet": "Hier ist noch nichts.",
    "removeEmptyCollection": "Leere Sammlung entfernen?",
    "removeNameAndItsSchema": "„{{name}}“ und ihr Schema entfernen?",
    "removeCollection": "Sammlung entfernen",
    "text": "Text",
    "theSvgMustBeUnder16": "Das SVG muss kleiner als 16 KiB sein.",
    "thisFileIsNotAUsable": "Diese Datei ist kein verwendbares SVG (Skripte und externe Verweise werden entfernt; das Wurzelelement muss <svg> sein).",
    "collectionName": "Sammlung: {{name}}",
    "sharedFieldsApplyToEveryPage": "Gemeinsame Felder gelten für jede Seite dieser Sammlung. Jede Seite kann zusätzlich eigene Felder haben.",
    "cancel": "Abbrechen",
    "saving": "Wird gespeichert …",
    "saveCollection": "Sammlung speichern",
    "createCollection": "Sammlung erstellen",
    "identity": "Identität",
    "nameAndIconAsTheTree": "Name und Symbol, wie sie in der Baumansicht und auf den Seiten erscheinen.",
    "name": "Name",
    "collectionName2": "Name der Sammlung",
    "magic": "Magie",
    "aCollectionWithThisNameAlready": "Eine Sammlung mit diesem Namen gibt es bereits.",
    "icon": "Symbol",
    "iconSource": "Symbolquelle",
    "lucide181": "Lucide (181)",
    "yourSvg": "Dein SVG",
    "collectionIcon": "Sammlungssymbol",
    "searchLucideIcons": "Lucide-Symbole durchsuchen",
    "searchIconsCastleSwordMoon": "Symbole suchen — Burg, Schwert, Mond …",
    "loadingIcons": "Symbole werden geladen …",
    "lucideIcon": "Lucide-Symbol",
    "noIconMatches": "Kein Symbol passt.",
    "chooseAnSvgFile": "SVG-Datei auswählen",
    "customSvgIcon": "Eigenes SVG-Symbol",
    "upTo16KibScriptsLinks": "Bis zu 16 KiB. Skripte, Links und externe Verweise werden entfernt; verwende currentColor in der Datei, damit die Sammlungsfarbe gilt.",
    "colour": "Farbe",
    "aPresetOneYouUsedRecently": "Eine Vorgabe, eine kürzlich verwendete oder deine eigene vom Farbrad.",
    "collectionColour": "Sammlungsfarbe",
    "recent": "Zuletzt verwendet",
    "useHex": "{{hex}} verwenden",
    "kindOfPage": "Art der Seite",
    "everyPageIsACodexEntry": "Jede Seite ist ein Kodex-Eintrag einer Art; die Art bestimmt, wie Prüfungen, @-Erwähnungen und der Graph sie behandeln, und behält überall ihre Farbe.",
    "collectionBaseKind": "Basisart der Sammlung",
    "magicOrShipsConceptDeitiesOr": "Magie oder Schiffe → Konzept · Gottheiten oder Häuser → Figur oder Fraktion · eine Sammlung von Städten → Ort.",
    "sharedFields": "Gemeinsame Felder",
    "thePropertiesOfTheCollectionValues": "Die Eigenschaften der Sammlung — die Werte stehen auf jeder Seite, und eine Seite kann trotzdem eigene hinzufügen.",
    "collectionTemplate": "Sammlungsvorlage",
    "template": "Vorlage …",
    "addField": "Feld hinzufügen",
    "exampleMagicLevelNumberRarityChoice": "Beispiel: Magie → Stufe (Zahl) · Seltenheit (Auswahl: gewöhnlich, selten, legendär) · Erlangt (Datum der Geschichte) · Gelehrt von (Eintragsverweis).",
    "collectionFieldNameValue": "Feldname der Sammlung {{value}}",
    "fieldName": "Feldname",
    "collectionFieldTypeValue": "Feldtyp der Sammlung {{value}}",
    "collectionFieldOptionsValue": "Feldoptionen der Sammlung {{value}}",
    "optionsOnePerLine": "Optionen, eine pro Zeile",
    "required": "Pflichtfeld",
    "requiredCollectionFieldValue": "Pflichtfeld der Sammlung {{value}}",
    "removeCollectionFieldValue": "Sammlungsfeld {{value}} entfernen",
    "yesNo": "Ja / Nein",
    "multipleChoice": "Mehrfachauswahl",
    "storyDate": "Datum der Geschichte",
    "entryLink": "Eintragsverweis",
    "multipleEntryLinks": "Mehrere Eintragsverweise",
    "fieldParagraph": "Absatz",
    "fieldNumber": "Zahl",
    "fieldChoice": "Auswahl"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Cloud-Versionen der Welt",
    "includesCodexPagesCollectionsFoldersFacts": "Enthält Kodex-Seiten, Sammlungen, Ordner, Fakten, Beziehungen und Anhänge. Veröffentliche oder lade eine Version ausdrücklich herunter. Das Manuskript nutzt die Szenensynchronisierung.",
    "compareVersions": "Versionen vergleichen",
    "recoverPreviousWorld": "Vorherige Welt wiederherstellen …",
    "deviceRevision": "Stand auf dem Gerät",
    "accountVersionRemoteversion": "Kontoversion {{remoteVersion}}",
    "firstAccountVersion": "Erste Kontoversion",
    "uploadDeviceVersion": "Geräteversion hochladen …",
    "useAccountVersion": "Kontoversion verwenden …",
    "confirmTransfer": "Übertragung bestätigen",
    "replaceWorldOnThisDeviceWith": "Die Welt auf diesem Gerät durch diese Version ersetzen? Zuvor bleibt eine Kopie der aktuellen Welt und der Anhänge erhalten. Der Manuskripttext bleibt unverändert.",
    "saveThisCopyToYourAccount": "Diese Kopie in deinem Konto speichern? Frühere Kontoversionen bleiben erhalten.",
    "restoreWorldFromBeforeTheLast": "Die Welt von vor der letzten Übertragung wiederherstellen? Spätere Änderungen verhindern diese Wiederherstellung.",
    "confirm": "Bestätigen",
    "cancel": "Abbrechen",
    "transferring": "Wird übertragen …",
    "codexPages": "Kodex-Seiten",
    "updateStoryideBeforePublishingChangesTo": "Aktualisiere Musael, bevor du Änderungen an diesem Archiv veröffentlichst.",
    "theAccountVersionChangedCompareAgain": "Die Kontoversion hat sich geändert. Vergleiche erneut, bevor du sie anwendest.",
    "worldChangedOnThisDeviceCompare": "Die Welt hat sich auf diesem Gerät geändert. Vergleiche erneut, bevor du sie anwendest.",
    "accountVersionStorageIsFullPrevious": "Der Speicher für Kontoversionen ist voll. Frühere Kopien bleiben erhalten.",
    "anAttachmentFailedItsIntegrityCheck": "Ein Anhang hat die Integritätsprüfung nicht bestanden. Keine lokale Kopie wurde ersetzt.",
    "theAccountCopyFailedItsIntegrity": "Die Kontokopie hat die Integritätsprüfung nicht bestanden.",
    "noRecoveryCopyIsAvailableFor": "Für diese Übertragung ist keine Wiederherstellungskopie verfügbar.",
    "anIdentifierIsAlreadyUsedIn": "Eine Kennung wird bereits in einem anderen Projekt verwendet.",
    "openOrSyncTheManuscriptWith": "Öffne oder synchronisiere das Manuskript zuerst mit deinem Konto.",
    "yourAccountDoesNotHaveThe": "Dein Konto hat nicht die nötige Berechtigung.",
    "signInAgainThisSessionWas": "Melde dich erneut an. Diese Sitzung wurde widerrufen.",
    "transferCancelled": "Übertragung abgebrochen.",
    "transferFailedCheckYourConnectionAnd": "Übertragung fehlgeschlagen. Prüfe deine Verbindung und vergleiche erneut.",
    "couldNotReadTheRecoveryCopy": "Die Wiederherstellungskopie konnte nicht gelesen werden.",
    "mondoPrecedenteRipristinato": "Vorherige Welt wiederhergestellt.",
    "accountVersionVersionSaved": "Kontoversion {{version}} gespeichert.",
    "versionVersionAppliedToWorldOn": "Version {{version}} auf die Welt auf diesem Gerät angewendet.",
    "cancellationRequested": "Abbruch angefordert.",
    "labelFacts": "Fakten",
    "labelEvents": "Ereignisse",
    "labelKnowledge": "Wissen",
    "labelAnnotations": "Anmerkungen",
    "labelRelationships": "Beziehungen",
    "labelAttachments": "Anhänge",
    "labelCollections": "Sammlungen",
    "labelFolders": "Ordner",
    "changedCount_one": "{{count}} geändert",
    "changedCount_other": "{{count}} geändert"
  },
  "worldMaps": {
    "character": "Figur",
    "place": "Ort",
    "object": "Gegenstand",
    "faction": "Fraktion",
    "concept": "Konzept",
    "pinOf": "Pin: {{name}}",
    "pinMissing": "Pin eines fehlenden Eintrags",
    "missingEntry": "Fehlender Eintrag",
    "zoom": "Zoom",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "fitToView": "An Ansicht anpassen",
    "newMap": "Neue Karte",
    "newMapDescription": "Ein Bild von einem Ort, für Pins auf den Personen, Orten und Dingen, die dort sind.",
    "cancel": "Abbrechen",
    "saving": "Wird gespeichert …",
    "createMap": "Karte erstellen",
    "mapOf": "Karte von",
    "aNewPlace": "Ein neuer Ort",
    "placeName": "Name des Ortes",
    "placeNamePlaceholder": "Die Salzküste",
    "picture": "Bild",
    "choosePicture": "PNG, JPEG, WebP oder GIF auswählen",
    "pictureHint": "Bis zu 16 MB. Es wird einer der Anhänge des Eintrags.",
    "maps": "Karten",
    "mapsLead": "Setze Einträge als Pins auf die Bilder deiner Orte. Ein Ort mit eigener Karte öffnet sie, wenn du ihn anpinnst.",
    "noMapsYet": "Noch keine Karten",
    "noMapsText": "Gib einem Ort ein Bild und pinne dann die Einträge an, die dorthin gehören.",
    "addTheFirstMap": "Erste Karte hinzufügen",
    "onePin": "1 Pin",
    "pins": "{{count}} Pins",
    "inPlace": "auf {{place}}",
    "chooseAnEntryOrName": "Wähle einen Eintrag oder schreibe einen Namen für den Pin.",
    "mapTrail": "Übergeordnete Karten",
    "doneAdding": "Fertig",
    "addPin": "Pin hinzufügen",
    "labels": "Beschriftungen",
    "replacePicture": "Bild ersetzen",
    "removeMap": "Karte entfernen",
    "hintClick": "Klicke auf die Stelle der Karte, an die der Pin kommt.",
    "hintChoose": "Wähle rechts, worauf der Pin zeigt.",
    "pictureMissing": "Das Bild dieser Karte ist noch nicht auf diesem Gerät.",
    "pinDetails": "Pin-Details",
    "newPin": "Neuer Pin",
    "entry": "Eintrag",
    "chooseAnEntry": "Eintrag auswählen",
    "noEntryLabelOnly": "Kein Eintrag, nur eine Beschriftung",
    "labelOnTheMap": "Beschriftung auf der Karte",
    "labelDefault": "Der Name des Eintrags",
    "labelRequired": "Ohne Eintrag erforderlich",
    "placePin": "Pin setzen",
    "label": "Beschriftung",
    "openEntry": "Eintrag öffnen",
    "openItsMap": "Seine Karte öffnen",
    "position": "{{x}} % von links, {{y}} % von oben",
    "removePin": "Pin entfernen",
    "noPinsYet": "Noch keine Pins. Wähle „Pin hinzufügen“ und klicke dann auf die Karte.",
    "shownOn": "Angezeigt auf",
    "openEntryOf": "{{name}} öffnen",
    "removeMapTitle": "Karte von {{name}} entfernen?",
    "removeMapMessage": "Die Pins werden mit entfernt. Das Bild bleibt in den Anhängen des Eintrags."
  },
  "worldPanel": {
    "checks": "Prüfungen",
    "findAndFixConsistencyIssuesIn": "Die Fakten, Ereignisse und Beziehungen deiner Welt, verglichen mit dem Manuskript. Ohne KI.",
    "running": "Läuft …",
    "runChecks": "Prüfungen starten",
    "lastRunAt": "Letzter Durchlauf um {{time}}",
    "oneAtATime": "Immer nur einer",
    "exclusiveRelation": "Exklusive Beziehung",
    "noRelationIsExclusive": "Keine Beziehung ist exklusiv",
    "exclusivityType": "Art der Exklusivität",
    "oneSourcePerTarget": "Eine Quelle pro Ziel",
    "oneTargetPerSource": "Ein Ziel pro Quelle",
    "oneAtATimeHint": "Eine Beziehung, die jeweils nur für einen gelten kann, etwa „besitzt“: Zwei Besitzer derselben Sache zu denselben Zeitpunkten werden zum Konflikt.",
    "rulesNeedRelations": "Regeln nutzen deine Beziehungen. Füge unter „Verbindungen“ eine hinzu, etwa „besitzt“, und mache sie hier exklusiv.",
    "results": "Ergebnisse",
    "whatTheChecksLookFor": "Wonach die Prüfungen suchen",
    "twoHoldersAtOnce": "Zwei Inhaber zugleich",
    "eventsOutOfOrder": "Ereignisse in falscher Reihenfolge",
    "quotedPastItsLimit": "Über sein Limit hinaus zitiert",
    "linksToDeletedEntries": "Verweise auf gelöschte Einträge",
    "notesThatLostTheirPlace": "Notizen, die ihren Platz verloren haben",
    "relationsOverTime": "Beziehungen im Zeitverlauf",
    "scopeOwnership": "Eine Sache, die zwei Einträge zu denselben Zeitpunkten halten, auf Grundlage bestätigter Fakten.",
    "scopeFlashback": "Ein Ereignis, das nach einem später in der Welt liegenden gelesen wird: eine Rückblende oder ein Versehen.",
    "scopeReveal": "Ein Fakt, der in einer Szene nach der letzten dafür erlaubten zitiert wird.",
    "scopeOrphans": "Notizen und Fakten, die auf einen Eintrag oder eine Bibliothekskarte verweisen, die es nicht mehr gibt.",
    "scopeAnchors": "Eine zitierte Passage, deren Wortlaut sich in ihrer Szene verschoben oder geändert hat.",
    "scopeRelations": "Beziehungen im Vergleich zur obigen Regel und zu den Zitaten, die sie anführen.",
    "filterResults": "Ergebnisse filtern",
    "all": "Alle",
    "conflicts": "Konflikte",
    "warnings": "Warnungen",
    "needsData": "Daten fehlen",
    "noIssuesFound": "Keine Probleme gefunden",
    "theExecutedRulesFoundNoViolation": "Nichts verstößt gegen die Fakten und Regeln, die du festgelegt hast. Die Prüfungen kennen nur das, was du erfasst hast.",
    "notEnoughData": "Nicht genug Daten",
    "quotesInTheText": "Zitate im Text",
    "anchorInPlace": "An Ort und Stelle",
    "anchorMoved": "Verschoben",
    "anchorGone": "Verschwunden",
    "reAnchor": "Neu verankern",
    "openScene": "Szene öffnen",
    "checkedAt": "Geprüft um {{time}}.",
    "twoHold": "{{a}} und {{b}} halten „{{object}}“ zur selben Zeit.",
    "heldTwice": "{{a}} hält „{{object}}“ doppelt zu denselben Zeitpunkten.",
    "flashbackSentence": "„{{earlier}}“ geschieht in der Welt vor „{{later}}“, wird aber danach gelesen: eine Rückblende – es sei denn, du wolltest keine.",
    "revealSentence": "„{{fact}}“ wird in {{scene}} zitiert, nach der letzten Szene, die du dafür erlaubt hast.",
    "allowedUpToScene": "Erlaubt bis Szene {{scene}}",
    "orphanFactSentence": "Ein Fakt („{{fact}}“) betrifft einen Eintrag, der gelöscht wurde.",
    "orphanNoteSentence": "Die Notiz zu „{{excerpt}}“ verweist auf einen gelöschten Eintrag.",
    "orphanConceptSentence": "Die Notiz zu „{{excerpt}}“ verweist auf eine Bibliothekskarte, die es nicht mehr gibt.",
    "movedSentence": "„{{excerpt}}“ hat sich in {{scene}} verschoben: Verankere die Notiz neu, damit sie folgt.",
    "eventWithoutTime": "„{{title}}“ hat keine Zeit in der Welt, daher lässt sich seine Reihenfolge nicht prüfen.",
    "factWithoutTime": "„{{fact}}“ hat keinen Zeitraum, daher lässt sich sein Inhaber nicht prüfen.",
    "recordWithoutTime": "Ein Datensatz hat keine Zeit und lässt sich daher nicht prüfen.",
    "aDeletedEntry": "ein gelöschter Eintrag",
    "aDeletedEvent": "ein gelöschtes Ereignis",
    "aScene": "eine Szene",
    "fromTo": "Von {{start}} bis {{end}}",
    "relativeToAnEvent": "Relativ zu einem Ereignis",
    "timeNotSet": "Nicht festgelegt",
    "facts": "Fakten",
    "factsLead": "Was du über jeden Eintrag festlegst. Die Prüfungen lesen die von dir bestätigten und vergleichen sie mit dem Manuskript.",
    "entries": "Einträge",
    "addAnEntry": "Eintrag hinzufügen",
    "addTheFirstEntry": "Ersten Eintrag hinzufügen",
    "newEntityName": "Name des neuen Eintrags",
    "entityType": "Eintragstyp",
    "addEntity": "Eintrag hinzufügen",
    "character": "Figur",
    "place": "Ort",
    "object": "Gegenstand",
    "faction": "Fraktion",
    "other": "Sonstiges",
    "deleteEntityReferencesBecomeOrphaned": "Eintrag löschen (Verweise werden verwaist)",
    "deleteEntityName": "Eintrag {{name}} löschen",
    "noFactYet": "Noch kein Fakt zu {{name}}. Ein neuer Fakt beginnt als Vorschlag; bestätige ihn, damit er zählt.",
    "proposed": "Vorgeschlagen",
    "confirmed": "Bestätigt",
    "rejected": "Abgelehnt",
    "superseded": "Ersetzt",
    "worldFact": "Weltfakt",
    "characterBelief": "Überzeugung",
    "testimony": "Aussage",
    "authorHypothesis": "Hypothese",
    "confirm": "Bestätigen",
    "confirmExplicitApproval": "Bestätigen (ausdrückliche Freigabe)",
    "newFactAbout": "Neuer Fakt zu {{name}}",
    "predicatePlaceholder": "besitzt",
    "predicate": "Prädikat",
    "valuePlaceholder": "das Schwert",
    "value": "Wert",
    "kind": "Art",
    "epistemicKind": "Epistemische Art",
    "kindHint": "Nur Weltfakten gelten als Wahrheit; Überzeugungen, Aussagen und Hypothesen werden aufbewahrt, aber nicht als Kanon geprüft.",
    "when": "Wann",
    "timeKind": "Zeitart",
    "betweenTwoMoments": "Zwischen zwei Zeitpunkten",
    "from": "Von",
    "to": "bis",
    "startTick": "Start-Tick",
    "endTick": "End-Tick",
    "momentsHint": "Zeitpunkte auf der Zeitleiste der Welt; das Ende zählt nicht mit.",
    "reveal": "Enthüllung",
    "maximumRevealNarrativeIndex": "Späteste Enthüllung (Erzählindex)",
    "noLimit": "Kein Limit",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Zitate dieses Fakts in einer späteren Szene werden markiert.",
    "addFactProposed": "Als Vorschlag hinzufügen",
    "selectAnEntityToSeeAnd": "Wähle einen Eintrag, um seine Fakten zu sehen und hinzuzufügen.",
    "noEntityYet": "Noch kein Eintrag. Füge oben oder im Kodex eine Figur, einen Ort oder einen Gegenstand hinzu.",
    "resultDetails": "Details zum Ergebnis",
    "conflict": "Konflikt",
    "warning": "Warnung",
    "whatWasCompared": "Was verglichen wurde",
    "whatToDo": "Was zu tun ist",
    "comparedOwnership": "Bestätigte Weltfakten mit Zeitraum. Zwei Inhaber derselben Sache dürfen sich nicht überschneiden.",
    "comparedFlashback": "Die Zeit jedes Ereignisses in der Welt im Vergleich zur Reihenfolge seiner Szene im Buch.",
    "comparedReveal": "Die letzte Szene, die du für einen Fakt erlaubt hast, im Vergleich zu den Szenen, die ihn zitieren.",
    "comparedOrphans": "Jede Notiz und jeder Fakt im Vergleich zu den vorhandenen Einträgen und Bibliothekskarten.",
    "comparedAnchors": "Das Zitat jeder Notiz im Vergleich zum aktuellen Text der Szene.",
    "confirmOnlyOneOwnerInThe": "Behalte für diese Zeitpunkte nur einen Inhaber: Grenze einen der Zeiträume ein oder setze einen Fakt zurück auf „Vorgeschlagen“.",
    "ifTheSceneIsADeliberate": "Ist die Szene eine bewusste Rückblende, lass sie so. Andernfalls verschiebe die Szene oder ändere die Zeit des Ereignisses.",
    "raiseTheMaximumRevealSceneOf": "Erlaube dem Fakt eine spätere Szene oder verschiebe das Zitat nach vorn.",
    "restoreTheMissingEntityFromThe": "Stelle den Eintrag aus dem Kodex-Verlauf wieder her oder lösche die Notiz oder den Fakt, die auf ihn verweisen.",
    "useReAnchorManualOnThe": "Nutze „Neu verankern“ beim Zitat in den Ergebnissen oder öffne die Szene und markiere die Passage erneut.",
    "giveTheEventOrFactAn": "Gib ihm eine Zeit in der Welt oder lass es ohne: Die Prüfung schweigt, statt zu raten.",
    "selectAResult": "Ergebnis auswählen",
    "detailsConstraintsAndSuggestedFixesAppear": "Was verglichen wurde und was zu tun ist, erscheint hier.",
    "thisAnnotationCannotBeReAnchored": "Diese Notiz lässt sich nicht neu verankern: „{{excerpt}}“ fehlt oder kommt in der Szene mehrfach vor.",
    "revisionTools": "Überarbeitungswerkzeuge",
    "loadingRevisionTools": "Überarbeitungswerkzeuge werden geladen …"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "Der Inhalt hat sich während der Bestätigung geändert. Wähle den Inhalt und die Freigabe, die du geprüft hast.",
    "theseChangesCannotBeCombinedInto": "Diese Änderungen lassen sich nicht zu einer gültigen Welt kombinieren. Wähle die vollständige Version, die du behalten willst; beide Kopien bleiben in der Wiederherstellung.",
    "thisDevice": "Dieses Gerät",
    "yourAccount": "Dein Konto",
    "viewWorld": "Welt ansehen",
    "previousSharedValue": "Vorheriger gemeinsamer Wert",
    "theActionCouldNotFinishYour": "Die Aktion konnte nicht abgeschlossen werden. Deine lokalen Änderungen bleiben erhalten.",
    "worldSync": "Synchronisierung der Welt",
    "syncCodexPagesFactsTimelinesCollections": "Synchronisiere Kodex-Seiten, Fakten, Zeitleisten, Sammlungen und Anhänge über deine Geräte. Notizen und Skizzen werden unten eigenständig synchronisiert.",
    "syncWorldAutomatically": "Welt automatisch synchronisieren",
    "n1PendingChange": "1 ausstehende Änderung",
    "pendingPendingChanges": "{{pending}} ausstehende Änderungen",
    "syncNow": "Jetzt synchronisieren",
    "exportRecoveryCopies": "Wiederherstellungskopien exportieren",
    "compareBeforeSyncing": "Vor dem Synchronisieren vergleichen",
    "signInToTheLinkedAccount": "Melde dich beim verknüpften Konto an, um zu synchronisieren. Lokale Änderungen bleiben gespeichert.",
    "signInToCompareYourWorld": "Melde dich an, um deine Welt zu vergleichen und die Synchronisierung zu aktivieren.",
    "chooseYourStartingWorld": "Wähle deine Ausgangswelt",
    "bothCopiesHaveTheSameContent": "Beide Kopien haben denselben Inhalt.",
    "keepTheWorldOnThisDevice": "Behalte die Welt auf diesem Gerät oder verwende die Kopie in deinem Konto. Die vorherige lokale Welt und die Anhänge bleiben in der Wiederherstellung erhalten.",
    "keepThisDeviceSync": "Dieses Gerät behalten und synchronisieren",
    "useAccountCopySync": "Kontokopie verwenden und synchronisieren",
    "cancel": "Abbrechen",
    "reviewConcurrentChanges": "Gleichzeitige Änderungen prüfen",
    "chooseEachValueToKeepOther": "Wähle jeden Wert, den du behalten willst. Andere Änderungen werden automatisch zusammengeführt. Beide Versionen bleiben wiederherstellbar.",
    "applyReviewedChoices": "Geprüfte Auswahl anwenden",
    "syncingWorldAndAttachments": "Welt und Anhänge werden synchronisiert …",
    "codexPages": "Kodex-Seiten",
    "onThisDevice": "Auf diesem Gerät",
    "waitingToSync": "Wartet auf Synchronisierung",
    "syncing": "Synchronisiert …",
    "upToDate": "Auf dem neuesten Stand",
    "reviewNeeded": "Prüfung nötig",
    "emptyText": "(leerer Text)",
    "emptyList": "(leere Liste)",
    "worldStructure": "Struktur der Welt",
    "labelFacts": "Fakten",
    "labelEvents": "Ereignisse",
    "labelKnowledge": "Wissen",
    "labelAnnotations": "Anmerkungen",
    "labelRelationships": "Beziehungen",
    "labelAttachments": "Anhänge",
    "labelCollections": "Sammlungen",
    "labelFolders": "Ordner",
    "paused": "Pausiert",
    "addedCount_one": "{{count}} hinzugefügt",
    "addedCount_other": "{{count}} hinzugefügt",
    "removedCount_one": "{{count}} entfernt",
    "removedCount_other": "{{count}} entfernt",
    "changedCount_one": "{{count}} geändert",
    "changedCount_other": "{{count}} geändert",
    "removedValue": "Entfernt",
    "emptyValue": "Leer"
  },
  "worldReviewTools": {
    "deletedEntry": "Gelöschter Eintrag",
    "timeUnknown": "Zeit unbekannt",
    "storyTimeInterval": "Zeitraum der erzählten Zeit",
    "relativeToEventPreserved": "Relativ zu Ereignis (beibehalten)",
    "from": "Von",
    "until": "Bis",
    "characterKnowledge": "Wissen der Figuren",
    "couldNotCheckTheSavedManuscriptRetry": "Das gespeicherte Manuskript konnte nicht geprüft werden. Versuche es erneut.",
    "revisionTools": "Überarbeitungswerkzeuge",
    "changeImpact": "Auswirkung einer Änderung",
    "whatPointsToThisRecord": "Was verweist auf diesen Datensatz?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Nur ausdrückliche Verknüpfungen, auch indirekte. Das Ändern eines Datensatzes schreibt die davon abhängigen nicht um.",
    "impactRecord": "Datensatz für die Auswirkung",
    "chooseARecord": "Datensatz auswählen",
    "linkedRecordsWorldRevision": "verknüpfte Datensätze · Stand der Welt",
    "directLink": "Direkte Verknüpfung",
    "missingSourceScene": "Fehlende Quellszene",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Kein Datensatz verweist ausdrücklich auf diesen Eintrag. Unverknüpfter Fließtext liegt außerhalb dieser Prüfung.",
    "whenDidTheyLearnIt": "Wann haben sie es erfahren?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Erfasse Erwerb und Verwendung auf derselben Achse der erzählten Zeit. Vermutungen und Überzeugungen bleiben getrennt; die Kapitelreihenfolge gilt nie als erzählte Zeit.",
    "recordKnowledge": "Wissen erfassen",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "Speichern nicht möglich. Prüfe die Zeiträume oder brich ab und öffne neu, falls sich die Welt geändert hat.",
    "character": "Figur",
    "knowledgeCharacter": "Figur des Wissens",
    "chooseACharacter": "Figur auswählen",
    "fact": "Fakt",
    "knowledgeFact": "Fakt des Wissens",
    "chooseAConfirmedWorldFact": "Bestätigten Weltfakt auswählen",
    "acquired": "Erworben",
    "acquisitionSource": "Quelle des Erwerbs",
    "noSourceAttached": "Keine Quelle angehängt",
    "use": "Verwendung",
    "scene": "Szene",
    "chooseAScene": "Szene auswählen",
    "knownInformation": "Bekannte Information",
    "belief": "Überzeugung",
    "guess": "Vermutung",
    "passageSource": "Quelle der Passage",
    "noPassageAttached": "Keine Passage angehängt",
    "removeUse": "Verwendung entfernen",
    "addUse": "Verwendung hinzufügen",
    "confirmAndSave": "Bestätigen und speichern",
    "cancel": "Abbrechen",
    "missingFact": "Fehlender Fakt",
    "atUnknownRelativeTime": "zu unbekannter/relativer Zeit",
    "edit": "Bearbeiten",
    "couldNotRemoveTheRecordRefreshAndRetry": "Der Datensatz konnte nicht entfernt werden. Lade neu und versuche es erneut.",
    "checkSavedKnowledge": "Gespeichertes Wissen prüfen",
    "theWorldChangedSinceThisResultRunTheCheck": "Die Welt hat sich seit diesem Ergebnis geändert. Starte die Prüfung erneut.",
    "recordedUseIsEarlierThanAcquisition": "Die erfasste Verwendung liegt vor dem Erwerb",
    "recordedTimesAreInOrder": "Die erfassten Zeiten sind in der richtigen Reihenfolge",
    "beliefOrGuessNotAKnowledgeConflict": "Überzeugung oder Vermutung — kein Wissenskonflikt",
    "notEnoughInformationToCompare": "Nicht genug Informationen zum Vergleichen",
    "attachedPassagesMatchTheSavedText": "Angehängte Passagen stimmen mit dem gespeicherten Text überein",
    "aSourceIsMissingStaleOrBelongsToAnother": "Eine Quelle fehlt, ist veraltet oder gehört zu einer anderen Szene",
    "authorRecordedTimesPassagesAreNotVerified": "Von dir erfasste Zeiten; Passagen sind nicht verifiziert",
    "openScene": "Szene öffnen",
    "noConfirmedKnowledgeUsesToCompare": "Keine bestätigten Wissensverwendungen zum Vergleichen.",
    "openNamedScene": "{{title}} öffnen",
    "recordSummary": "Verwendungen: {{count}} · {{lifecycle}} · Erworben {{time}}",
    "checkSummary": "Geprüft um {{time}} · {{count}} erfasste Verwendungen. Aktualisiere nach Änderungen am Text.",
    "resultsLimitedTo500Records": "Ergebnisse auf 500 Datensätze begrenzt",
    "linksAway": "{{depth}} Verknüpfungen entfernt",
    "useNKind": "Verwendung {{n}}: Art",
    "useN": "Verwendung {{n}}",
    "useNSource": "Verwendung {{n}}: Quelle",
    "checking": "Prüfe …"
  },
  "worldSection": {
    "overview": "Übersicht",
    "vault": "Archiv",
    "timeline": "Zeitleiste",
    "connections": "Verbindungen",
    "references": "Verweise",
    "checks": "Prüfungen",
    "analysis": "Analyse",
    "characters": "Figuren",
    "locations": "Orte",
    "factions": "Fraktionen",
    "objects": "Gegenstände",
    "concepts": "Konzepte",
    "worldViews": "Weltansichten",
    "world": "Welt",
    "browseByType": "Nach Typ durchsuchen",
    "filterByType": "Nach Typ filtern",
    "all": "Alle",
    "newEntry": "Neuer Eintrag",
    "cercaNelCodex": "Kodex durchsuchen",
    "searchEntries": "Einträge durchsuchen …",
    "entry": "Eintrag",
    "entries": "Einträge",
    "alsoAliases": "Auch: {{aliases}}",
    "noEntriesYetCreateTheFirst": "Noch keine Einträge. Erstelle die erste Figur, den ersten Ort oder die erste Fraktion.",
    "noEntryMatches": "Kein Eintrag passt.",
    "editName": "{{name}} bearbeiten",
    "edit": "Bearbeiten",
    "archive": "Archivieren",
    "confirmArchive": "Archivieren bestätigen",
    "notesAndSketches": "Notizen und Skizzen",
    "alsoKnownAs": "Auch bekannt als",
    "addADescriptionOneLineThat": "Füge eine Beschreibung hinzu — eine Zeile, die sagt, was das ist.",
    "none": "Keine",
    "yes": "Ja",
    "no": "Nein",
    "removedEntry": "Entfernter Eintrag",
    "unavailableEntry": "Eintrag nicht verfügbar",
    "noNotesYetEditTheEntry": "Noch keine Notizen. Bearbeite den Eintrag, um ihn zu beschreiben.",
    "linkedScenes": "Verknüpfte Szenen",
    "showTheEntriesOfABook": "Einträge eines Buchs anzeigen",
    "allBooks": "Alle Bücher",
    "bookLine": "Buch {{number}} · {{title}}",
    "inNoBookYet": "In noch keinem Buch",
    "scenesThatMentionThisEntryBy": "Szenen, die diesen Eintrag mit Namen oder Alias erwähnen, erscheinen hier.",
    "facts": "Fakten",
    "noFactRecordedFactsAreAdded": "Kein Fakt erfasst. Fakten werden in den Prüfungen hinzugefügt und freigegeben.",
    "relations": "Beziehungen",
    "noRelationYet": "Noch keine Beziehung.",
    "proposed": " · vorgeschlagen",
    "viewAll": "Alle ansehen",
    "attachments": "Anhänge",
    "attachAnImageToUseIt": "Hänge ein Bild an, um es als Porträt zu verwenden.",
    "kib": "KiB",
    "open": "Öffnen",
    "remove": "Entfernen",
    "addAttachment": "Anhang hinzufügen",
    "stateAtStoryTime": "Zustand zur erzählten Zeit",
    "tick": "Tick",
    "factsWithoutACompleteInterval": "Fakten ohne vollständigen Zeitraum.",
    "selectAnEntry": "Eintrag auswählen",
    "charactersPlacesFactionsAndObjectsLive": "Figuren, Orte, Fraktionen und Gegenstände leben hier, mit ihren Fakten, Beziehungen und Anhängen.",
    "recentChanges": "Letzte Änderungen",
    "undoChange": "Änderung rückgängig machen",
    "worldTimeline": "Zeitleiste der Welt",
    "eventsPeopleAndPlacesInA": "Ereignisse, Personen und Orte in einem größeren Zusammenhang.",
    "noEventYet": "Noch kein Ereignis",
    "addTheFirstEventWithA": "Füge das erste Ereignis mit einer erzählten Zeit hinzu oder lass die Zeit unbekannt, bis du sie kennst.",
    "tick2": "Tick",
    "plotEvent": "Handlungsereignis",
    "worldEvent": "Weltereignis",
    "openScene": "Szene öffnen",
    "unknownTime": "Unbekannte Zeit",
    "unknown": "unbekannt",
    "seeHowYourWorldSPeople": "Sieh, wie die Personen, Orte und Ideen deiner Welt zusammenhängen.",
    "connectionsView": "Verbindungsansicht",
    "graph": "Graph",
    "list": "Liste",
    "nothingToConnectYet": "Noch nichts zu verbinden",
    "createEntriesInTheCodexAnd": "Erstelle Einträge im Kodex und setze sie in der Listenansicht in Beziehung.",
    "selectedEntry": "Ausgewählter Eintrag",
    "relationSummary": "Zusammenfassung der Beziehungen",
    "noSceneMentionsThisEntryYet": "Noch keine Szene erwähnt diesen Eintrag.",
    "openInCodex": "Im Kodex öffnen",
    "selectANodeToSeeIts": "Wähle einen Knoten, um seine Beziehungen und Szenen zu sehen.",
    "annotationsAnchoredInTheManuscriptAnd": "Im Manuskript verankerte Annotationen und die Dateien, die du für deine Welt aufbewahrst.",
    "addFile": "Datei hinzufügen",
    "annotations": "Annotationen",
    "selectTextInTheManuscriptAnd": "Markiere Text im Manuskript und nutze „Annotieren“, um ein Stilmittel, einen Eintrag oder eine Notiz zu verankern.",
    "scene": "Szene",
    "device": "Stilmittel",
    "entity": "Eintrag",
    "note": "Notiz",
    "imagesPdfsNotesAndAudioYou": "Bilder, PDFs, Notizen und Audio, die du an die Welt oder an einen Eintrag hängst.",
    "linked": "Verknüpft",
    "orphan": "Verwaist",
    "openFile": "Datei öffnen",
    "referenceDetails": "Details zum Verweis",
    "textAnnotation": "Textannotation",
    "kind": "Art",
    "anchor": "Anker",
    "concept": "Konzept",
    "created": "Erstellt",
    "anchorStatesValidStaleOrphanedAnd": "Ankerzustände (gültig, veraltet, verwaist) und das Neuverankern werden in den Prüfungen berechnet.",
    "attachment": "Anhang",
    "type": "Typ",
    "size": "Größe",
    "linkedTo": "Verknüpft mit",
    "added": "Hinzugefügt",
    "confirmRemove": "Entfernen bestätigen",
    "selectAnAnnotationOrAFile": "Wähle eine Annotation oder eine Datei.",
    "exploreTheShapeOfYourStory": "Erkunde die Form deiner Geschichte: Länge, Präsenz und Dichte über die Szenen hinweg.",
    "sceneLength": "Länge der Szenen",
    "wordsPerScene": "Wörter pro Szene",
    "noScenesYet": "Noch keine Szenen.",
    "titleFmtWords": "{{title}}: {{fmt}} Wörter",
    "entityDensity": "Eintragsdichte",
    "codexMentionsPerScene": "Kodex-Erwähnungen pro Szene",
    "titleMentionsMentions": "{{title}}: {{mentions}} Erwähnungen",
    "characterAppearanceMap": "Auftrittskarte der Figuren",
    "aDotWhereACharacterIs": "Ein Punkt, wo eine Figur in einer Szene genannt wird",
    "addCharactersToTheCodexAnd": "Füge dem Kodex Figuren hinzu und nenne sie in Szenen.",
    "thisScene": "Diese Szene",
    "words": "Wörter",
    "paragraphs": "Absätze",
    "sentencesEst": "Sätze (geschätzt)",
    "distinctWords": "Verschiedene Wörter",
    "annotatedDevices": "Annotierte Stilmittel",
    "n1000Words": "/ 1.000 Wörter",
    "repetitions": "Wiederholungen",
    "exportHtml": "HTML exportieren",
    "exportTxt": "TXT exportieren",
    "events": "Ereignisse",
    "confirmedFacts": "Bestätigte Fakten",
    "recentlyChanged": "Zuletzt geändert",
    "changesToTheWorldWillBe": "Änderungen an der Welt werden hier aufgelistet, jede mit einem Rückgängig.",
    "undo": "Rückgängig",
    "startHere": "Hier beginnen",
    "overviewEmptyLead": "Die Personen, Orte und Ereignisse deiner Geschichte, verknüpft mit den Szenen, in denen sie vorkommen.",
    "addACharacter": "Figur hinzufügen",
    "addACharacterText": "Wer sie ist, was sie will und was ihr im Weg steht.",
    "addAPlace": "Ort hinzufügen",
    "addAPlaceText": "Wo Szenen spielen: eine Stadt, ein Schiff, ein einzelner Raum.",
    "addAnEventText": "Etwas, das in der Geschichte geschieht, mit Datum oder ohne.",
    "inThisWorld": "In dieser Welt",
    "createAnEntry": "Eintrag erstellen",
    "aCharacterAPlaceAFaction": "Eine Figur, ein Ort, eine Fraktion, ein Gegenstand oder ein Konzept.",
    "addAnEvent": "Ereignis hinzufügen",
    "withAnExactStoryTimeOr": "Mit genauer erzählter Zeit oder einer unbekannten.",
    "runTheChecks": "Prüfungen starten",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Besitzer, Reihenfolge, Enthüllungen und Beziehungen im Zeitverlauf, verglichen mit dem Text.",
    "loadingTheWorld": "Welt wird geladen …",
    "maps": "Karten",
    "openItsMap": "Seine Karte öffnen",
    "addAMap": "Karte hinzufügen",
    "pinnedOn": "Angepinnt auf",
    "typeCharacter": "Figur",
    "typeLocation": "Ort",
    "typeObject": "Objekt",
    "typeFaction": "Fraktion",
    "typeConcept": "Konzept",
    "annotationsToReAnchor_one": "{{count}} Anmerkung neu zu verankern.",
    "annotationsToReAnchor_other": "{{count}} Anmerkungen neu zu verankern."
  }
}
